var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard3C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M467.4,325.7c-1.2-2.3-4.1-4.4-5.4-6.5c-8.2-12.7-7.8-45.2-8.8-70.8c0.2-1.9,0.2-0.3,0,0 c-5.1,7.7-3.2,33.1-4.1,42.6c-1,10.5-3.4,17.6-10.6,25.7c-7.5,8.6-13.3,13.1-15.5,23.9c-0.6,3.1-1,12.5-5.3,13.4 c-5.5,1.1-8.4-7-10.3-10c-4.5-7.5-11.5-16.3-20.6-15.1c-4.8,0.7-9.3,4.7-13.8,6.2c-9.1,3.4-21.9,1.4-29.8-1.2 c-4.5-1.5-7.1-3.9-11.9-4.6c-9.1-1.3-19.3,9-23.8,16.5c-1.8,3.1-5.3,11.7-10.8,10.6c-4.3-0.8-5-12.7-5.6-15.8 c-2.2-10.8-8-15.3-15.5-23.9c-7.1-8.2-7.3-14.8-8.3-25.3c-0.9-9.5,3.2-33.8-2.8-42.2c0,20.2-1.5,39.2-7.5,58.2 c-2.7,8.4-9.6,18.3-10.8,20.6c3-1.4,9.5-6.9,11.4-10.1c-1,8.7-5.8,15.7-8.9,23.7c3,0.4,5.9-1.8,8.4-2.9c1.6,6.9-1.4,18.5-3.6,24.9 c3.8,0.1,9.9-2.3,10.7-5.7c0.1,5.7-0.4,10.6-1.3,16c4.4,0.3,10.9-3.2,12-7.1c2.8,6.6,3.9,10.6,6,18.4c1.3,4.7,0.3,4.9,4.8,2.4 c2.3-1.2,4.9-5.8,5.9-8.1c3,7.8,18.7,8,22.5,12.8c-5.5-23-0.3-48,21.6-51.1c9.1-1.3,8.8-1.2,19.4-1.1l0,0c0.6,0,1.1,0,1.6,0 c0.6,0,1.2,0,1.9,0l0,0c11.2-0.1,19.3-0.5,28.5,0.8c21.9,3.1,23,33.9,12,53.4c4.1-2.8,19.9-7,22.9-14.8c1,2.3,3.7,6.8,5.9,8.1 c4.5,2.5,3.1,2.1,4.8-2.4c2.5-6.2,4.1-12.4,6-18.4c1.2,3.8,7.6,7.4,12,7.1c-1-5.4-1.4-10.3-1.3-16c0.9,3.3,6.9,5.8,10.7,5.7 c-2.1-6.5-5.2-15.3-3.6-22.2c2.4,1.1,5,2.4,8.1,2c-4.7-7.4-8.6-14.4-9.5-23.1C457.5,323.6,463.5,325.4,467.4,325.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard3C);
export default __webpack_public_path__ + "static/media/man_beard_3c.e781f99539aeb2771adaa03d6ce9989b.svg";
export { ForwardRef as ReactComponent };